<template>
  <v-card
    max-width="350"
    class="mx-auto mt-5"
  >
    <v-card-text class="text--primary">
      <v-row>
        <v-col cols="12">
          Insira o CNPJ da sua empresa:
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            required
            hide-details
            label="CNPJ"
            v-mask="'##.###.###/####-##'"
            :error="$v.cnpj.$error"
            @blur="$v.cnpj.$touch()"
            v-model="cnpj"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="primary"
             :disabled="$v.$invalid"
             :loading="loading"
             @click="onCriarConta">
        Criar conta
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { isValid } from '@/utils/validate-cnpj';
import FornecedorService from './fornecedor-service';

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('criarConta', ['rawCnpj']),
    cnpj: {
      get() {
        return this.$store.getters['criarConta/cnpj'];
      },
      set(user) {
        this.$store.dispatch('criarConta/cnpj', user);
      },
    },
  },
  methods: {
    onCriarConta() {
      this.loading = true;
      FornecedorService.validar(this.rawCnpj)
        .then((response) => {
          if (response.data.valido) {
            this.$router.push({ name: 'conta-existente' });
            return;
          }
          this.$router.push({ name: 'nova-conta-empresa' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  validations: {
    cnpj: {
      required,
      validateCnpj(value) {
        return isValid(value);
      },
    },
  },
};
</script>
